export const SLIDER_DEFAULTS = {
    sliderLeft: 0,
    sliderWidth: 0,
    isSliderMoving: false,
    isSliderTouched: false,
    sliderVerseIndex: -1,
}
